const FacebookIcon = '/images/Home-page/latest-image/facebook.svg';
const LinkedInIcon = '/images/Home-page/latest-image/linkedin.svg';
const InstagramIcon = '/images/Home-page/latest-image/instagram.svg';
const XIcon = '/images/Home-page/latest-image/twitter.svg';
const PinterestIcon = '/images/Home-page/latest-image/pinterest.svg';
const YouTubeIcon = '/images/Home-page/latest-image/youtube.svg';
const TelegramIcon = '/images/Home-page/latest-image/telegram.svg';

export const socialMediaData = [
    {icon: FacebookIcon, name: 'Facebook', redirect: 'https://www.facebook.com/debutinfotechusa'},
    {icon: LinkedInIcon, name: 'LinkedIn', redirect: 'https://www.linkedin.com/company/debut-infotech-pvt-ltd'},
    {icon: InstagramIcon, name: 'Instagram', redirect: 'https://www.instagram.com/debutinfotech'},
    {icon: XIcon, name: 'X (Twitter)', redirect: 'https://x.com/debutinfotech'},
    {icon: PinterestIcon, name: 'Pinterest', redirect: 'https://in.pinterest.com/debutinfotech'},
    {icon: YouTubeIcon, name: 'YouTube', redirect: 'https://www.youtube.com/@DebutInfotechPvtLtd'},
    {icon: TelegramIcon, name: 'Telegram', redirect: 'https://t.me/debutinfotech'}
];
